module.exports = __webpack_public_path__ + "assets/img/safe.d38c1fc6.svg";